"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransparentUpgradeableProxyFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var TransparentUpgradeableProxyFactory = /** @class */ (function (_super) {
    __extends(TransparentUpgradeableProxyFactory, _super);
    function TransparentUpgradeableProxyFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    TransparentUpgradeableProxyFactory.prototype.deploy = function (_logic, admin_, _data, overrides) {
        return _super.prototype.deploy.call(this, _logic, admin_, _data, overrides || {});
    };
    TransparentUpgradeableProxyFactory.prototype.getDeployTransaction = function (_logic, admin_, _data, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _logic, admin_, _data, overrides || {});
    };
    TransparentUpgradeableProxyFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    TransparentUpgradeableProxyFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    TransparentUpgradeableProxyFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return TransparentUpgradeableProxyFactory;
}(contracts_1.ContractFactory));
exports.TransparentUpgradeableProxyFactory = TransparentUpgradeableProxyFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: '_logic',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'admin_',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: '_data',
                type: 'bytes',
            },
        ],
        stateMutability: 'payable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'previousAdmin',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'newAdmin',
                type: 'address',
            },
        ],
        name: 'AdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'implementation',
                type: 'address',
            },
        ],
        name: 'Upgraded',
        type: 'event',
    },
    {
        stateMutability: 'payable',
        type: 'fallback',
    },
    {
        inputs: [],
        name: 'admin',
        outputs: [
            {
                internalType: 'address',
                name: 'admin_',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newAdmin',
                type: 'address',
            },
        ],
        name: 'changeAdmin',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'implementation',
        outputs: [
            {
                internalType: 'address',
                name: 'implementation_',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newImplementation',
                type: 'address',
            },
        ],
        name: 'upgradeTo',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newImplementation',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'upgradeToAndCall',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=TransparentUpgradeableProxyFactory.js.map